export default {
      id: "obd__mileage-usage",
      viewBox: "0 0 38 22",
      url: __webpack_public_path__ + "img/icons.svg#obd__mileage",
      toString: function () {
        return this.url;
      }
    }